import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';

const { BaseFilters, EnvironmentFilter } = Filters;

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const TraceEnvironmentFilter = {
  ...EnvironmentFilter,
  oDataField: 'environment/id',
  apiRoute: 'environment/allowed',
  lazy: false,
};

const TraceActorFilter = {
  ...BaseFilters.EnumFilter,
  name: 'actor',
  label: 'traces.text.actor',
  enumNamespace: getEnumNamespace(CoreEnums.TraceActor),
  enumSource: CoreEnums.TraceActor,
  options: createEnumOptions(CoreEnums.TraceActor, 'traces.actor'),
};

const TraceOperationFilter = {
  ...BaseFilters.EnumFilter,
  name: 'operation',
  label: 'traces.text.operation',
  enumNamespace: getEnumNamespace(CoreEnums.TraceOperation),
  enumSource: CoreEnums.TraceOperation,
  options: createEnumOptions(CoreEnums.TraceOperation, 'traces.operation', { casing: 'camel' }),
};

const IsSuccessfulOperationFilter = {
  ...BaseFilters.BooleanFilter,
  name: 'isSuccessfulOperation',
  label: 'traces.text.isSuccessfulOperation',
};

export const filtersConfig = [
  CreatedDateFilter,
  TraceEnvironmentFilter,
  TraceActorFilter,
  TraceOperationFilter,
  IsSuccessfulOperationFilter,
];

registerModuleFilters('traces', filtersConfig);
